import React from 'react';
import { useDeviationBlockType } from '../../hooks/useDeviationBlockType';
import BlockedSubscribedMiddleContent from './_partials/BlockedSubscribedMiddleContent';
import NeedsSubscriptionMiddleContent from './_partials/NeedsSubscriptionMiddleContent';
import PremiumLockedMiddleContent from './_partials/PremiumLockedMiddleContent';
import WatchersOnlyMiddleContent from './_partials/WatchersOnlyMiddleContent';
import ContentFilterMiddleContent from './_partials/ContentFilterMiddleContent';
import BlockedMiddleContent from './_partials/BlockedMiddleContent';
const DeviationThumbMiddleContent = ({ deviation , thumbHeight , thumbWidth , className , children , isMatureBlock  })=>{
    const blockType = useDeviationBlockType(deviation);
    switch(blockType){
        case 'matureFilter':
            // mature blocks have had their styles updated
            // - other overlays no longer match
            const FeatureSplitComponent = isMatureBlock ? ContentFilterMiddleContent : BlockedMiddleContent;
            return /*#__PURE__*/ React.createElement(FeatureSplitComponent, {
                deviation: deviation,
                thumbWidth: thumbWidth,
                thumbHeight: thumbHeight,
                className: className
            });
        case 'premiumFolder':
            return /*#__PURE__*/ React.createElement(PremiumLockedMiddleContent, {
                deviation: deviation,
                thumbWidth: thumbWidth,
                thumbHeight: thumbHeight,
                className: className
            });
        case 'watchersOnly':
            return /*#__PURE__*/ React.createElement(WatchersOnlyMiddleContent, {
                deviation: deviation,
                thumbWidth: thumbWidth,
                thumbHeight: thumbHeight,
                className: className
            });
        case 'subsOnly':
            return /*#__PURE__*/ React.createElement(NeedsSubscriptionMiddleContent, {
                deviation: deviation,
                thumbWidth: thumbWidth,
                thumbHeight: thumbHeight,
                className: className
            });
        case 'subBlocked':
            return /*#__PURE__*/ React.createElement(BlockedSubscribedMiddleContent, {
                thumbWidth: thumbWidth,
                thumbHeight: thumbHeight,
                className: className
            });
        default:
            return /*#__PURE__*/ React.createElement(React.Fragment, null, children);
    }
};
DeviationThumbMiddleContent.displayName = 'DeviationThumbMiddleContent';
export default DeviationThumbMiddleContent;
